export default [
    {
        path: "/credit",
        name: "credit list",
        component: () => import("@/views/Credit.vue"),
        meta: {
            resource: "credit",
            pageTitle: "Credits",
            breadcrumb: [
                {
                    text: "Credits",
                    active: true
                }
            ]
        }
    },
    
    
    {
        path: "/client",
        name: "client list page",
        component: () => import("@/views/Client/ClientList.vue"),
        meta: {
            resource: "client",
            pageTitle: "Clients",
            breadcrumb: [
                {
                    text: "Clients",
                    active: true
                }
            ]
        }
    },
    {
        path: "/client/create",
        name: "client create",
        component: () => import("@/views/Client/ClientUpsert.vue"),
        meta: {
            resource: "client",
            pageTitle: "Client Create",
            breadcrumb: [
                {
                    text: "Client Create",
                    active: true
                }
            ]
        }
    },
    {
        path: "/client/:id/edit",
        name: "client edit",
        component: () => import("@/views/Client/ClientUpsert.vue"),
        meta: {
            resource: "client",
            pageTitle: "Client Edit",
            breadcrumb: [
                {
                    text: "Client Edit",
                    active: true
                }
            ]
        }
    },
    {
        path: "/employee",
        name: "employee list",
        component: () => import("@/views/Employee/List.vue"),
        meta: {
            resource: "client",
            pageTitle: "Employees",
            breadcrumb: [
                {
                    text: "Employees",
                    active: true
                }
            ]
        }
    },
    {
        path: "/employee/create",
        name: "employee create",
        component: () => import("@/views/Employee/Upsert.vue"),
        meta: {
            resource: "client",
            pageTitle: "Employee Create",
            breadcrumb: [
                {
                    text: "Employee Create",
                    active: true
                }
            ]
        }
    },
    {
        path: "/employee/:id/edit",
        name: "employee edit",
        component: () => import("@/views/Employee/Upsert.vue"),
        meta: {
            resource: "client",
            pageTitle: "Employee Edit",
            breadcrumb: [
                {
                    text: "Employee Edit",
                    active: true
                }
            ]
        }
    },
    {
        path: "/user-approval",
        name: "user-approval list",
        component: () => import("@/views/Client/UserApproval.vue"),
        meta: {
            resource: "client",
            pageTitle: "User Approvals",
            breadcrumb: [
                {
                    text: "User Approvals",
                    active: true
                }
            ]
        }
    },
    {
        path: "/user-approval/:id",
        name: "user-approval update",
        component: () => import("@/views/Client/UserApprovalEdit.vue"),
        meta: {
            resource: "client",
            pageTitle: "User Approvals",
            breadcrumb: [
                {
                    text: "Update",
                    active: true
                }
            ]
        }
    },

    {
        path: "/invoice",
        name: "invoice list",
        action: "invoice list",
        component: () => import("@/views/Invoice/List.vue"),
        meta: {
            resource: "credit",
            pageTitle: "Invoices",
            breadcrumb: [
                {
                    text: "Invoices",
                    active: true
                }
            ]
        }
    },
    {
        path: "/invoice/create",
        name: "invoice create",
        component: () => import("@/views/Invoice/Add.vue"),
        meta: {
            resource: "credit",
            pageTitle: "Invoice Create",
            breadcrumb: [
                {
                    text: "Invoice Create",
                    active: true
                }
            ]
        }
    },
    {
        path: "/invoice/:id/view",
        name: "invoice show",

        component: () => import("@/views/Invoice/Show.vue"),
        meta: {
            action: "invoice list",
            resource: "credit",
            pageTitle: "Invoice",
            breadcrumb: [
                {
                    text: "Invoice",
                    active: true
                }
            ]
        }
    },
    {
        path: "/logs",
        name: "custom logs",

        component: () => import("@/views/Logs/List.vue"),
        meta: {
            resource: "client",
            pageTitle: "Logs",
            breadcrumb: [
                {
                    text: "Logs",
                    active: true
                }
            ]
        }
    }
];
